import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import StartScreen from "./components/StartScreen/StartScreen";
import LeaderBoard from "./components/LeaderBoard";
import { useFetchCompetition } from "./hooks/Api-hooks";
import styles from './index.module.css'
import { REACT_APP_ENV } from "./api-contants";

import ChangeUser from "./components/ChangeUser/ChangeUser";
import {staticGameId} from "./api-contants.js";

function App() {

  const [currentOperator, setOperator] = useState({});

  useEffect(() => {
    let pathname = window.location.host;
    function setOperatorFromPathName(pathname) {
      if(process.env.REACT_APP_ICE === 'ICE') {
        setOperator({ name: "pine", id: 7770110 });
        return;
      }
      switch (true) {
        case pathname.includes("yrsa"):
          setOperator({ name: "yrsa", id: 8880001 });
          break;
        case pathname.includes("daniel"):
          setOperator({ name: "daniel", id: 8880003 });
          break;
        case pathname.includes("vaida"):
          setOperator({ name: "vaida", id: 8880004 });
          break;
        case pathname.includes("eddie"):
          setOperator({ name: "eddie", id: 8880005 });
          break;
        case pathname.includes("filip"):
          setOperator({ name: "filip", id: 8880006 });
          break;
        case pathname.includes("jens"):
          setOperator({ name: "jens", id: 8880007 });
          break;
        case pathname.includes("robin"):
          setOperator({ name: "robin", id: 8880008 });
          break;
        case pathname.includes("miro"):
          setOperator({ name: "miro", id: 8880008 });
          break;
        case pathname.includes("tejag"):
          setOperator({ name: "tejag", id: 1234 });
          break;
        case pathname.includes("jonas"):
          setOperator({ name: "jonas", id: 8880008 });
          break;
        case pathname.includes("helena"):
          setOperator({ name: "helena", id: 8880012 });
          break;
        case pathname.includes("rolf"):
          setOperator({ name: "rolf", id: 8880013 });
          break;
        case pathname.includes("andrea"):
          setOperator({ name: "andrea", id: 8880014 });
          break;
        case pathname.includes("oak"):
          if (REACT_APP_ENV === "DEMO") {
            setOperator({ name: "oak", id: 7770129 });
          } else {
            setOperator({ name: "oak", id: 9990129 });
          }
          break;
        case pathname.includes("ash"):
          if (REACT_APP_ENV === "DEMO") {
            setOperator({ name: "ash", id: 7770130 });
          } else {
            setOperator({ name: "ash", id: 9990130 });
          }
          break;
        case pathname.includes("maple"):
          if (REACT_APP_ENV === "DEMO") {
            setOperator({ name: "maple", id: 7770198, currency: "USD" });
          } else {
            setOperator({ name: "maple", id: 9990198, currency: "USD" });
          }
          break;
        // case pathname.includes("pine"):
        default:
          if (REACT_APP_ENV === "DEMO") {
            setOperator({ name: "pine", id: 7770110 });
          } else {
            setOperator({ name: "pine", id: 9990110 });
          }
      }
    };

    setOperatorFromPathName(pathname);
  }, [currentOperator.id]);

  const { competition, loading } = useFetchCompetition(
    `/competition/competitions`,
    currentOperator.id
  );
  if(loading) {
    return <div>Loading...</div>;
  }
  if(((!competition && !staticGameId) || competition.length < 1)) {
    return (
        <div className={`${styles.startscreencontainer}`}>
          <div
              className={`${styles.startscreenImage}`}
              style={{
                  backgroundImage: `url(${require(`./img/Portrait-Default.jpg`)}`
              }}>
              <div className={`${styles.menu}`}>              
                  <div style={{
                    marginTop: `85%`,
                    textAlign: `center`
                  }}>
                    <button
                      onClick={() => window.open('https://www.elk-studios.com/elk-compete/', '_self')}
                      className={`${styles.menuItem}`}
                    >
                      ABOUT ELK COMPETE
                    </button>
                  </div>
              </div>
          </div>
      </div>
    );
  }

  if(process.env.REACT_APP_ICE === 'ICE') {
    return <Router className="App">
      <LeaderBoard
              competition={competition}
              currentOperator={currentOperator}/>
    </Router>;
  }

  return <Router className="App">
      <Switch>
        <Route
          exact
          path="/"
          render={() => <Redirect to={(currentOperator.id === 9990110 || currentOperator.id === 7770110)?`/lobby`:`/${currentOperator.name}`} />}
        />
        <Route
          exact
          path={`/lobby`}
          render={props => (
            <StartScreen
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />
        <Route
          exact
          path={`/${currentOperator.name}`}
          render={props => (
            <StartScreen
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />
        {competition ? (<Route
          exact
          path={`/leaderboard`}
          render={() => (
            <LeaderBoard
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />): (<Route
          exact
          path={`/leaderboard`}
          render={() => (
            <StartScreen
              currentOperator={currentOperator}
            />
          )}
        />)}
        {competition ? (<Route
          exact
          path={`/${currentOperator.name}/leaderboard`}
          render={() => (
            <LeaderBoard
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />): (<Route
          exact
          path={`/${currentOperator.name}/leaderboard`}
          render={() => (
            <StartScreen
              currentOperator={currentOperator}
            />
          )}
        />)}
        <Route
          exact
          path={`/${currentOperator.name}/changeuser`}
          render={() => (
            <ChangeUser
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />
        <Route
          exact
          path={`/changeuser`}
          render={() => (
            <ChangeUser
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />
      </Switch>
    </Router>;
}

export default App;

/* NOTE: routes for big competition stuff
        <Route
          exact
          path={`/${currentOperator.name}/changeuser`}
          render={() => (
            <LoginComponent
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />
        <Route
          exact
          path={`/login`}
          render={() => (
            <LoginComponent
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />
        <Route
          exact
          path={`/welcome`}
          render={() => (
            <WelcomeScreenComponent
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />
        <Route
          exact
          path={`/${currentOperator.name}/welcome`}
          render={() => (
            <WelcomeScreenComponent
              competition={competition}
              currentOperator={currentOperator}
            />
          )}
        />
*/
